// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"39a28e16","401":"4070c178","444":"3b30e00f","656":"a6b77b6a","717":"a5f6539f","737":"284c0741","750":"118f89ab"}[chunkId] + ".chunk.js";
};